import { createContext, useContext, useMemo, useRef, useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";

import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { useNavigate } from "react-router-dom";
import { getCourses, updateCourses } from "../../api/home";
import { generatePayload, getIntialValues } from "./helper";
import { getCoursesList } from "../../api/courses";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const navigate = useNavigate();
  const coursesRef = useRef();

  const [setTerm] = useState("");

  const getCoursesQuery = useQuery({
    queryKey: [""],
    queryFn: getCourses,
  });

  const getCoursesListQuery = useQuery({
    queryKey: [{ limit: 200, is_published: true }],
    queryFn: getCoursesList,
  });

  const updateCoursesQuery = useMutation({ mutationFn: updateCourses });

  const initialValues = useMemo(() => {
    const homeData = getCoursesQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getCoursesQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getCoursesQuery?.data?.data?.data?.[0] || {};

    updateCoursesQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getCoursesQuery.refetch();
        },
      },
    );
    return;
  };

  const handleAddBlogClick = () => {
    navigate("/courses/add");
  };

  const handleEditClick = (item) => {
    navigate(`/courses/add?id=${item.id}`);
  };

  const handleOnChange = (e) => {
    const { value } = e.target;
    setTerm(value);
  };

  return (
    <PageContext.Provider
      value={{
        coursesRef,
        getCoursesListQuery,
        handleAddBlogClick,
        handleEditClick,
        handleSubmit,
        initialValues,
        handleOnChange,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};

export const useBlogsProvider = () => {
  return useContext(PageContext);
};
